import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { MensagensApiService } from 'app/api/mensagensApi.service';
import { AlertModalService } from 'app/shared/alert-modal.service';

@Component({
  selector: 'app-mensagens-cadastrar',
  templateUrl: './mensagens-cadastrar.component.html',
  styleUrls: ['./mensagens-cadastrar.component.css']
})
export class MensagensCadastrarComponent implements OnInit, OnDestroy {

  addForm: FormGroup;
  idCliente: number;
  submitted = false;

  private subs = new SubSink();

  constructor(
    private mensagensService: MensagensApiService,
    private alertService: AlertModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private location: Location) { }

  ngOnInit() {

    this.addForm = this.formBuilder.group({
      destinatarios: ['', [
        Validators.required,
        Validators.email
      ]],
      cc: [''],
      cco: [''],
      assunto: [''],
      corpo: [''],
      enviarImediatamente: [Boolean],
      corpoEhHtml: [Boolean]
    });
  }

  get f() { return this.addForm.controls; }

  validarEmail(email) {
    // Expressão regular básica para validar o formato do e-mail
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }


  processarMensagem(condition: boolean): void {

    this.submitted = true;

    let inputCC = null;
    let inputCCO = null;

    if(this.addForm.get('destinatarios').value == '') {
      this.alertService.showAlertDanger('O campo "Destinatário" é obrigatório.');
      document.getElementById('destinatarios').focus();
      return;
    }

    if(this.addForm.get('destinatarios').value) {
      let checkEmail = this.validarEmail(this.addForm.get('destinatarios').value);
      if(!checkEmail) {
        this.alertService.showAlertDanger('O campo "Destinatário" deve ter um e-mail válido.');
        document.getElementById('destinatarios').focus();
        return;
      }
    }

    if(this.addForm.get('cc').value) {
      let checkEmail = this.validarEmail(this.addForm.get('cc').value);
      if(!checkEmail) {
        this.alertService.showAlertDanger('O campo "CC" deve ter um e-mail válido.');
        document.getElementById('cc').focus();
        return;
      }
      inputCC = [this.addForm.get('cc').value];
    }

    if(this.addForm.get('cco').value) {
      let checkEmail = this.validarEmail(this.addForm.get('cco').value);
      if(!checkEmail) {
        this.alertService.showAlertDanger('O campo "CCO" deve ter um e-mail válido.');
        document.getElementById('cco').focus();
        return;
      }
      inputCCO = [this.addForm.get('cco').value];
    }

    this.addForm.setValue({
      destinatarios: [this.addForm.get('destinatarios').value],
      cc: inputCC,
      cco: inputCCO,
      assunto: this.addForm.get('assunto').value,
      corpo: this.addForm.get('corpo').value,
      enviarImediatamente: condition,
      corpoEhHtml: true
    });

    this.subs.sink = this.mensagensService.v1MensagensPost(this.addForm.value)
    .subscribe(success => {
      let message = 'Mensagem enviada com sucesso!';
      if(!condition) {
        message = 'Rascunho salvo com sucesso!';
      }
      this.alertService.showAlertSuccess(message);
      this.router.navigate(['mensagens']);
    }, error => {
      console.error("Erro:", error);
      let message = 'Erro ao enviar a mensagem. Tente novamente.';
      if(!condition) {
        message = 'Erro ao salvar o rascunho. Tente novamente.';
      }
      if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
        this.alertService.showAlertDanger(error.Erros[0].Mensagem);
      } else {
        this.alertService.showAlertDanger(message);
      }
    });
  }

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
